import { Field, InputType } from 'type-graphql'

@InputType()
export class BasicAuthChangePasswordArgs {
  @Field(() => String)
  recaptchaToken: string

  @Field(() => String)
  newPassword: string

  @Field(() => String)
  confirmPassword: string

  @Field(() => String)
  _id: string
}
